import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppShell from "./components/AppShell";
import Dashboard from "./pages/Dashboard";
import ReassignAdmin from "./reassign/pages/ReassignAdmin";
import Wizard from "./pages/Wizard";
import SchedulerHome from "./scheduling/pages/SchedulerHome";
import ClientView from "./scheduling/pages/ClientView";
import EmployeeProfile from "./scheduling/pages/EmployeeProfile";
import StaffSuggestions from "./scheduling/pages/StaffSuggestions";
import SchedulerGrid from "./scheduling/pages/SchedulerGrid";
import Reporting from "./scheduling/pages/Reporting";
import SchedulerDashboard from "./scheduling/pages/Dashboard";
import NotificationsPage from "./scheduling/pages/Notifications";
import AdminConsole from "./scheduling/pages/AdminConsole";
import IDDReview from "./scheduling/pages/IDDReview";
import JobPools from "./scheduling/pages/JobPools";
import { AuthProvider } from "./auth/AuthContext";
import "./App.css";
import "./components/Brand.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* ── Unified app shell (single header for all pages) ── */}
          <Route element={<AppShell />}>
            {/* Default: land on scheduler */}
            <Route path="/" element={<Navigate to="/schedule" replace />} />

            {/* ── Scheduling section ── */}
            <Route path="/schedule" element={<SchedulerHome />} />
            <Route path="/schedule/grid" element={<SchedulerGrid />} />
            <Route path="/schedule/reporting" element={<Reporting />} />
            {/* Capacity moved into Reporting as a tab. Kept as a redirect because
                these URLs are shared and the navbot grounding docs reference them. */}
            <Route path="/schedule/capacity" element={<Navigate to="/schedule/reporting?tab=capacity" replace />} />
            <Route path="/schedule/notifications" element={<NotificationsPage />} />
            <Route path="/schedule/dashboard" element={<SchedulerDashboard />} />
            <Route path="/schedule/client/:clientId" element={<ClientView />} />
            <Route path="/schedule/employee/:staffId" element={<EmployeeProfile />} />
            <Route path="/schedule/suggestions/:jobId" element={<StaffSuggestions />} />
            <Route path="/schedule/data-integrity" element={<IDDReview />} />
            <Route path="/schedule/pool" element={<JobPools />} />
            <Route path="/schedule/admin" element={<AdminConsole />} />

            {/* ── Reassignments section ── */}
            <Route path="/reassign/dashboard" element={<Dashboard />} />
            <Route path="/reassign/admin" element={<ReassignAdmin />} />
            <Route path="/reassign/wizard" element={<Wizard />} />

            {/* Legacy redirects (preserve old bookmarks) */}
            <Route path="/dashboard" element={<Navigate to="/schedule" replace />} />
            <Route path="/admin" element={<Navigate to="/reassign/admin" replace />} />
            <Route path="/wizard" element={<Navigate to="/reassign/wizard" replace />} />
          </Route>

          {/* 404 fallback */}
          <Route path="*" element={<div style={{padding:24}}>Page not found</div>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}